<template>
  <div class="search" @click.stop="historyShow = false">
    <div class="searchBox" @click.stop="historyShow = true">
      <van-search v-model="remark" placeholder="请输入搜索关键词" 
        @search="onSearch" 
        @keydown.native.enter="searchRemark" 
      />
    </div>
    <div class="history" v-if="historyShow && historyList.length>0" >
      <div class="title">搜索历史</div>
      <div class="container">
        <div class="item" v-for="(item,index) in historyList" :key="index" @click="setRemark(index)">
          <span style="margin-right: 5px;">{{item}}</span><i class="el-icon-close" style="font-size: 16px" @click.stop="deleteHistory(index)"></i>
        </div>
      </div>
    </div>
    <div class="questions" v-if="detailsListShow && reporterList.length>0" >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDetailList" >
                <van-cell >
                    <div class="item" v-for="(item,index) in reporterList" :key="index">
                        <div class="itemTitle" @click="jumpUrl(item.webIntQaId)">
                            {{item.webIntQaTitle}}
                        </div>
                        <div class="userMsg">
                            <img :src="item.createUserAvatar?getimgUrl(item.createUserAvatar):require('@/assets/questionsAndAnswer/user.png')" alt="" @click="jumpUserUrl(item.createUser)">
                            <div class="userName">
                                {{item.createUserName}}
                            </div>
                        </div>
                        <!-- 纯文本展示 -->
                        <div class="question" v-if="item.webIntQaContent"> 
                            {{ item.webIntQaContent }}
                        </div>
                        <!-- 图片列表展示 -->
                        <div class="picture " v-if="item.webAttType == 4" @click="jumpUrl(item.webIntQaId)">
                            <div class="onePicture" v-if="item.fileObjIds && item.fileObjIds.length==1">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div class="twoPicture" v-if="item.fileObjIds && item.fileObjIds.length==2">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                            </div>
                            <div class="morePicture" v-if="item.fileObjIds && item.fileObjIds.length==3">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <div class="picRight">
                                    <div class="top">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                                    </div>
                                    <div class="bottom" style="position: relative;">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[2]):''" alt="">
                                        <div style="width: 36px;height: 20px;position: absolute;bottom: 8px;right: 8px;background-color: rgba(0,0,0,.3);
                                            text-align: center;font-size: 12px;border-radius: 10px;color: #fff;">
                                            {{item.fileObjIds.length}}图
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <!-- 视频展示 -->
                        <div class="picture" v-if="item.webAttType == 2" style="position: relative;" @click="jumpUrl(item.webIntQaId)">
                            <div class="onePicture">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div style="position: absolute; top: 50%;left: 50%;transform: translate(-50%,-50%);">
                              <img src="@/assets/questionsAndAnswer/playVideo.png" alt="">
                          </div>
                        </div>
                        <div class="footer">
                            <div class="createTime">
                                {{ item.createTime }}
                            </div>
                            <div class="replyNum">
                                <div class="replyPic">
                                    <img src="@/assets/questionsAndAnswer/huifu.png" alt="">
                                </div>
                                <div >{{item.replyCount?item.replyCount:'--'}}</div>
                            </div>
                        </div>
                    </div>
                </van-cell>
            </van-list>
    </div>
    <div class="seizeSeat" v-if="detailsListShow && reporterList.length==0" >
      <img src="@/assets/questionsAndAnswer/zwt.png" alt="">
    </div>
  </div>
</template>

<script>
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
import { interactiveqaPage,interactiveqaHotpage } from "@/api/questionsAndAnswer/index.js"
import { Toast } from 'vant';
export default {
    data(){
        return{
          remark:'', // 搜索框输入内容
          historyList:JSON.parse(window.localStorage.getItem('searchHistory'))||[], // 搜索历史记录
          historyShow:false, // 搜索历史记录显隐
          reporterList: [], // list数据
          finished:true, // 触底加载底部显示
          loading:false,  // loading 加载状态
          detailsListShow:false, // 搜索结果显隐
          pageNum:0,
        }
    },
    mounted(){
      document.title="问答"
    },
    methods:{
      // 键盘上面的回车触发搜索
      onSearch(val){
        
      },
      // pc端回车搜索
      searchRemark(val){
        this.pageNum = 0
        if(this.remark!=''){
          this.historyList.unshift(this.remark)
          this.getDetailList()
        }
        this.historyList= Array.from(new Set(this.historyList))
        window.localStorage.setItem('searchHistory',JSON.stringify(this.historyList))
        this.historyShow = false
        
      },
      // 失去焦点
      blurHstory(){
        this.historyShow = false
      },
      // 发起搜索
      searchStart(){
        this.pageNum = 1
      },
      // 删除历史
      deleteHistory(val){
        this.historyList.splice(val,1)
        window.localStorage.setItem('searchHistory',JSON.stringify(this.historyList))
      },
      // 获取列表数据
      getDetailList(){
        this.pageNum++
        let params={
          pageNum:this.pageNum,
          keyword:this.remark,
          webAudStatus:1,
          pageSize:10
        }
        interactiveqaPage(params).then(res=>{
          if(res.data.code == 200){
            this.reporterList = res.data.data.list
            this.detailsListShow = true
          }else{
            this.detailsListShow = true
            Toast(res.data.msg)
          }
        })
      },
      // 点击问题跳转详情
      jumpUrl(val){
        window.open('/questionsDetails?id=' + val,'_self')
      },
      // 跳转用户详情
      jumpUserUrl(val){
        window.open('/userQuestionsAnswer?webUserId='+val,'_self')
      },
      // 搜索历史赋值
      setRemark(val){
        this.pageNum = 0
        this.remark = this.historyList[val]
        this.getDetailList()
        this.historyShow =false
      },
      //获取图片
      getimgUrl(val) {
            return filePerviewPath({
                id: val,
                type: "cover"
            });
        }
    }
}
</script>

<style scoped lang="scss">
.search{
  width: 100%;
  min-height: 100vh;
  .searchBox{
    width: 98%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-top: 12px;
    border-radius: 20px;
    /deep/ .van-search__content{
      background-color: #F2F2F2;
      border-radius: 20px;
    }
    /deep/ .van-field__control{
      color: #999;
    }
  }
  .history{
    position: absolute;
    top: 66px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 16px 10px 16px;
    background-color: #fff;
    z-index: 2000;
    .title{
      width: 100%;
      color: #333333;
      font-size: 16px;
      margin-bottom: 16px;
    }
    .container{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .item{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 4px 12px;
        height: 28px;
        line-height: 28px;
        background-color: #F5F5F5;
        border-radius: 20px;
        font-size: 16px;
        margin-right: 12px;
        margin-bottom: 12px;
      }
    }
  }
  .questions{
    height: calc(100vh - 66px);
    overflow: hidden;
    overflow-y: auto;
    .item{
      width: 100%;
      background-color: #F8F9FD;
      box-sizing: border-box;
      padding: 16px 20px;
      .itemTitle{
          width: 100%;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }
      .userMsg{
          display: flex;
          align-items: center;
          width: 100%;
          height: 36px;
          margin-top: 20px;
          margin-bottom: 12px;
      }
      .userMsg img{
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
      }
      .userName{
          margin-left: 7px;
          color: #000;
      }
      .question{
          width: 100%;
          font-size: 14px;
          color: #666;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
      }
      .picture{
          margin-top: 10px;
          width: 100%;
      }
      .onePicture{
          width: 100%;
          height: 190px;
      }
      .onePicture img{
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
      }
      .twoPicture{
          width: 100%;
          height: 150px;
          display: flex;
          justify-content: space-between;
      }
      .twoPicture img{
          width: 48%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
      }
      .morePicture{
          width: 100%;
          height: 163px;
          display: flex;
          justify-content: space-between;
      }
      .morePicture img{
          width: 48%;
          border-radius: 4px;
          object-fit: cover;
      }
      .picRight{
          width: 48%;
          height: 100%;
      }
      .picRight .top{
          width: 100%;
          height: 48%;
          margin-bottom: 11px;
      }
      .picRight .bottom{
          width: 100%;
          height: 48%;
      }
      .picRight .top img{
          width: 100%;
          height: 100%;
      }
      .picRight .bottom img{
          width: 100%;
          height: 100%;
      }
      .footer{
          width: 100%;
          height: 17px;
          line-height: 17px;
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #999999;
          .createTime{
              font-size: 14px;
          }
          .replyNum{
              display: flex;
              align-items: center;
              font-size: 14px;
              .replyPic{
                  width: 14px;
                  height: 14px;
                  margin-right:4px;
                  img{
                      width: 14px;
                      height: 14px;
                  }
              }
          }
      }
      
  }
  }
  .seizeSeat{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-50%);
    width: 160px;
    height: 231px;
  }
}
</style>